import React from 'react'

function Footer() {
  return (
    <section className='footer'>
      
    </section>
  )
}

export default Footer;